/*
 * @Author: Doraemon 719771893@qq.com
 * @Date: 2022-08-17 11:42:00
 * @LastEditors: Doraemon 719771893@qq.com
 * @LastEditTime: 2022-08-19 17:59:25
 * @FilePath: \H5-activity\src\router\integralCenter.js
 * @Description: 
 * 
 * Copyright (c) 2022 by Doraemon 719771893@qq.com, All Rights Reserved. 
 */
const integralCenter = [
    {
        path: '/integralCenter1',
        name: 'integralCenter1',
        component: () => import('@/views/integralCenter/integralCenter'),
        meta: {
            title: '积分中心',
            keepAlive: true
        },
    },
    {
        path: '/shareSubsidy',
        name: 'shareSubsidy',
        component: () => import('@/views/integralCenter/shareSubsidy'),
        meta: {
            title: '共享补贴'
        }
    },
    {
        path: '/qrCode',
        name: 'qrCode',
        component: () => import('@/views/cytx_common/qrCode'),
        meta: {
            title: ''
        }
    },
    {
        path: '/commonRule',
        name: 'commonRule',
        component: () => import('@/views/cytx_common/rule'),
        meta: {
            title: ''
        }
    }
   
]

export default integralCenter